
<template>
  <div class="atividades-sinistros ml-4 mr-4">
    <b-form>
      <b-row>
        <!-- -->
        <!-- -->
        <b-col cols="4">
          <label for="select-empresa-cor">Empresa</label>
          <multiselect
            id="selecao-empresa-cor-ind"
            v-model="empresaf"
            :options="empresas"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="true"
            @close="loadFilial()"
            :preserve-search="true"
            placeholder="Selecione a empresa"
            label="nomeempresarial"
            track-by="nomeempresarial"
            name="nomeempresarial"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Empresa selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="3">
          <label for="select-filial_cor">Filial</label>
          <multiselect
            id="selecao-filial-coe-ind"
            v-model="valor_filial"
            :options="filiais"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Selecione a filial"
            label="filial"
            track-by="filial"
            name="filial"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Filial selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="2">
          <div>
            <label for="datepicker-placeholder">Data inicial</label>
            <b-form-datepicker
              id="dt_sol_inicial"
              required
              v-model="dt_inicial"
              placeholder="Data inicial "
              locale="pt-BR"
              date-format-options="DD/MM/YYYY"
            ></b-form-datepicker>
          </div>
        </b-col>

        <b-col cols="2">
          <div>
            <label for="datepicker-placeholder">Data final</label>
            <b-form-datepicker
              id="dt_sol_final"
              required
              v-model="dt_final"
              placeholder="Data do final"
              locale="pt-BR"
              date-format-options="DD/MM/YYYY"
            ></b-form-datepicker>
          </div>
        </b-col>

        <b-col cols="1" class="mt-4">
          <b-button
            size="sm"
            id="btn-pesquisar"
            variant="success"
            block
            class="mr-2 mt-1"
            @click="
              loadKpiDiario(),
                loadKpiFase(),
                loadKpiNatureza(),
                loadKpiFilial(),
                loadKpiResumo()
            "
          >
            <b-spinner v-if="carregando" small style="margin-bottom: 3px">
            </b-spinner>
            Filtrar gráfico
          </b-button>
        </b-col>

        <LoadingModal v-if="isLoading" />
      </b-row>
    </b-form>

    <!--  <b-card-group class="ml-3 mt-3 mb-3" deck>    -->
    <b-card-group class="ml-3 mt-3 mb-3 d-flex justify-content-center" deck>
      <b-card
        class="ml-2"
        style="width: 33rem"
        border-variant="primary"
        header="QUANTIDADE DE PROCESSO(s)"
        header-bg-variant="primary"
        header-text-variant="white"
        align="center"
      >
        <b-card-text>
          <h2>
            {{ kpiResumo.length }}
          </h2>
        </b-card-text>
      </b-card>

      <b-card
        class="ml-2"
        style="width: 33rem"
        border-variant="primary"
        header="VALOR CAUSA"
        header-bg-variant="primary"
        header-text-variant="white"
        align="center"
      >
        <b-card-text>
          <h2>
            {{ calcularTotalCausa() }}
          </h2>
        </b-card-text>
      </b-card>

      <b-card
        class="ml-2"
        style="width: 33rem"
        border-variant="primary"
        header="VALOR PAGO"
        header-bg-variant="primary"
        header-text-variant="white"
        align="center"
      >
        <b-card-text>
          <h2>
            {{ calcularTotalPago() }}
          </h2>
        </b-card-text>
      </b-card>
    </b-card-group>

    <!-- Painel -->
    <!-- Painel -->
    <!-- Painel -->

    <template>
      <div>
        <!-- diário  -->
        <b-row>
          <b-col cols="12" class="mt-4" id="grafdia">
            <apexcharts
              ref="chartdia"
              height="400"
              :options="graficoDia"
              :series="seriesdia"
            >
            </apexcharts>
          </b-col>
        </b-row>

        <!-- acumulado  -->
        <b-row>
          <!-- acumulado  função -->
          <b-col cols="5">
            <apexcharts
              ref="chartfase"
              height="400"
              :options="graficoFase"
              :series="seriesfase"
            ></apexcharts>
          </b-col>

          <!-- acumulado  carro -->
          <b-col cols="4">
            <apexcharts
              ref="chartfuncionario"
              height="400"
              :options="graficoNatureza"
              :series="seriesNatureza"
            ></apexcharts>
          </b-col>

          <!-- acumulado  FILIAL -->
          <b-col cols="3">
            <apexcharts
              ref="chart"
              height="400"
              :options="graficoPizzaFilial"
              :series="graficoPizzaFilial.series"
            >
            </apexcharts>
          </b-col>
        </b-row>
      </div>
    </template>

    <!-- Painel -->
    <!-- Painel -->
    <!-- Painel -->
  </div>
</template>


<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
import moment, { now } from "moment";
import { mapState } from "vuex";
import VueApexCharts from "vue-apexcharts";
import { onBeforeUpdate } from "vue";
import LoadingModal from "../utilitarios/LoadingModal";

export default {
  name: "SolicitacaoPainel",

  components: {
    apexcharts: VueApexCharts,
    Multiselect,
    LoadingModal,
  },
  computed: { ...mapState(["user"]) },

  data: function () {
    return {
      isLoading: false,

      /* diario */
      graficoDia: {
        chart: {
          id: "bar-dia",
          type: "area",
          height: 350,
          foreColor: "black",
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          categories: [],
          tickPlacement: "of",
        },

        dataLabels: {
          style: {
            fontSize: "18px", // Defina o tamanho da fonte dos valores nas barras
          },
          enabled: true,
        },

        title: {
          text: "LINHA DO TEMPO",
          align: "center",
          margin: 10,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize: "22px",
            fontWeight: "bold",
            color: "#263238",
          },
        },
      },

      /* Função    */
      graficoFase: {
        chart: {
          id: "bar-material",
          type: "bar",
          height: 350,
          foreColor: "black",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },

        yaxis: {
          labels: {
            style: {
              fontSize: "18px", // Labels das categorias (eixo Y)
              fontFamily: "Arial, sans-serif",
            },
          },
        },
        xaxis: {
          labels: {
            maxWidth: 400,
            style: {
              fontSize: "10px", // Valores numéricos (eixo X)
            },
          },
          categories: [],
          tickPlacement: "of",
        },

        dataLabels: {
          style: {
            fontSize: "18px", // Defina o tamanho da fonte dos valores nas barras
          },
          enabled: true,
        },

        title: {
          text: "FASE",
          align: "center",
          margin: 10,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize: "22px",
            fontWeight: "bold",
            color: "#263238",
          },
        },
      },

      /* NATUREZA */
      graficoNatureza: {
        chart: {
          id: "bar-Natureza",
          type: "bar",
          height: 350,
          foreColor: "black",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        xaxis: {
          labels: {
            maxWidth: 400,
            style: {
              fontSize: "10px", // Valores numéricos (eixo X)
            },
          },
          categories: [],
          tickPlacement: "of",
        },
        yaxis: {
          labels: {
            style: {
              fontSize: "18px", // Labels das categorias (eixo Y)
              fontFamily: "Arial, sans-serif",
            },
          },
        },
        dataLabels: {
          style: {
            fontSize: "18px",
          },
          enabled: true,
        },
        title: {
          text: "NATUREZA",
          align: "center",
          margin: 10,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize: "22px",
            fontWeight: "bold",
            color: "#263238",
          },
        },
        legend: {
          show: true,
          fontSize: "16px",
          fontFamily: "Arial, sans-serif",
          fontWeight: 400,
          labels: {
            colors: ["#000"],
            useSeriesColors: false,
          },
        },
      },

      /* filial */
      graficoPizzaFilial: {
        chart: {
          id: "pizza-filial",
          type: "pie",
          height: 350,
          foreColor: "black",
          //fontFamily: 'Arial, sans-serif', // Defina a fonte desejada
          fontSize: "122px", // Tamanho da fonte
        },
        labels: [],
        legend: {
          show: true,
          position: "bottom",
        },
        dataLabels: {
          style: {
            fontSize: "18px", // Defina o tamanho da fonte dos valores nas barras
          },
          enabled: true,
        },

        title: {
          text: "FILIAIS",
          align: "center",
          margin: 10,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize: "22px",
            fontWeight: "bold",
            color: "#263238",
          },
        },
      },

      ///////////////////  venda perdida
      /* Percentual */
      graficoPortalPercentual: {
        chart: {
          id: "RadialBar-percentual",
          type: "radialBar",
          height: 350,

          foreColor: "black",
          toolbar: {
            show: false,
          },
          colors: ["#20E647"],
        },
        plotOptions: {
          radialBar: {
            hollow: {
              margin: 0,
              size: "70%",
              background: "#293450",
            },
            track: {
              dropShadow: {
                enabled: true,
                top: 2,
                left: 0,
                blur: 4,
                opacity: 0.15,
              },
            },
            dataLabels: {
              name: {
                offsetY: -10,
                color: "#fff",
                fontSize: "13px",
              },
              value: {
                color: "#fff",
                fontSize: "30px",
                show: true,
              },
            },
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            type: "vertical",
            gradientToColors: ["#87D4F9"],
            stops: [0, 100],
          },
        },
        stroke: {
          lineCap: "round",
        },
        labels: ["ATENDIMENTO"],
      },

      empresaf: "",
      empresas: [], // [] lista
      filiais: [],
      filiaisf: [], // [] lista
      valor_filial: [],
      tipo: "",
      tipos: [],

      /* objetos */

      kpiResumo: [],
      kpitipos: [],
      kpidias: [],
      kpidiastotal: [], // calcular a média de dias
      kpiprograma: [],
      kpifuncionario: [],
      kpifiliais: [],
      kpifase: [],
      seriestipo: [],
      seriesdia: [],
      seriesprograma: [],
      seriesNatureza: [],
      seriesfase: [],
      seriesPizzaFilial: [],

      /*
  dt_inicial: '',
  dt_final: '',  
*/
      dt_inicial: this.getPrimeiroDiaDoMes(),
      dt_final: this.getUltimoDiaDoMes(),

      sinistros: [],
      seriesPizzaFilial: [],
      seriesColunaDia: [],
      seriesfilial: [],
      value_empresa: [], // [this.empresas],
      permissoes: [],
      permissao: {},

      mode: "save",
      carregando: false,
      atualizando: false,
      value_filial: [],
      value_status: [],
    };
  },

  methods: {
    // Função para pegar o primeiro dia do mês
    getPrimeiroDiaDoMes() {
      const hoje = new Date();
      hoje.setDate(1); // Configura para o primeiro dia do mês
      return this.formatarData(hoje);
    },

    // Função para pegar o último dia do mês
    getUltimoDiaDoMes() {
      const hoje = new Date();
      hoje.setMonth(hoje.getMonth() + 1); // Vai para o próximo mês
      hoje.setDate(0); // Configura para o último dia do mês anterior (que é o mês atual)
      return this.formatarData(hoje);
    },

    // Função para formatar a data no formato 'yyyy-MM-dd'
    formatarData(data) {
      const ano = data.getFullYear();
      const mes = (data.getMonth() + 1).toString().padStart(2, "0"); // Meses começam do 0 (Jan é 0, Dez é 11)
      const dia = data.getDate().toString().padStart(2, "0");
      return `${ano}-${mes}-${dia}`;
    },

    calcularTotalPago() {
      const total = this.kpiResumo.reduce((acc, item) => {
        const valor = parseFloat(item.vlrsentenca) || 0;
        return acc + valor;
      }, 0);

      // Formatar como moeda brasileira
      return total.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },

    calcularTotalCausa() {
      const total = this.kpiResumo.reduce((acc, item) => {
        const valor = parseFloat(item.vlrcausa) || 0;
        return acc + valor;
      }, 0);

      // Formatar como moeda brasileira
      return total.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },

    loadEmpresa() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios
        .get(url, { params })
        .then((res) => {
          this.empresas = res.data.map((emp) => {
            return {
              ...emp,
              value: emp.id_empresa,
              empresa: emp.nomeempresarial,
              id_filial_erp: emp.id_filial_erp,
            };
          });
        })
        .catch(showError);
    },

    loadFilial() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/ctr/empresa/filial`;
      axios
        .get(url, { params })
        .then((res) => {
          this.filiais = res.data.map((emp) => {
            return {
              ...emp,
              value: emp.id_filial_erp,
              filial: emp.filial,
              empresa_id: emp.empresa_id,
            };
          });
        })
        .catch(showError);
    },

    /// qtd solicitações card kpi
    async loadKpiResumo() {
      let params = {
        psg: this.user.psg,
        empresa_id: `${[this.user.id_empresa]}`,
        filial_id: `${[this.valor_filial.map((f) => f.id_filial_erp)]}`,
        dt_inicial: `${this.dt_inicial}`,
        dt_final: `${this.dt_final}`,
        filtro: "RESUMO",
      };
      const url = await `${baseApiUrl}/jur/indicadores/kpijurResumo`;
      axios
        .get(url, { params })
        .then((res) => {
          this.kpiResumo = res.data;
        })
        .catch(showError);
    },

    /// filtros por dia (PERIODO) 10/07/2024
    async loadKpiDiario() {
      let params = {
        psg: this.user.psg,
        empresa_id: `${[this.user.id_empresa]}`,
        filial_id: `${[this.valor_filial.map((f) => f.filial_id)]}`,
        dt_inicial: `${this.dt_inicial}`,
        dt_final: `${this.dt_final}`,
        filtro: "DIA",
      };
      const url = await `${baseApiUrl}/jur/indicadores/kpijurDiario`;
      axios
        .get(url, { params })
        .then((res) => {
          this.kpidias = res.data;
          this.updateChartDataDia();
        })
        .catch(showError);
    },
    async updateChartDataDia() {
      this.seriesdia = [
        {
          name: "Qtds",
          data: this.kpidias.map((item) => parseInt(item.dia)),
        },
      ];
      this.$refs.chartdia.updateOptions({
        xaxis: {
          //categories: this.kpidias.map(item => moment(item.dt_visualizacao).format('DD'))
          //categories: this.kpidias.map(item => moment(item.dt_visualizacao).locale('PT-BR').format('DD/MM/YYYY'))
          categories: this.kpidias.map((dt) =>
            moment(dt.dt_recebimento).locale("PT-BR").format("DD/MM")
          ),
        },
      });
    },

    // filtros por função 06/12/2023 as 15:45h
    async loadKpiFase() {
      let params = {
        psg: this.user.psg,
        empresa_id: `${[this.user.id_empresa]}`,
        filial_id: `${[this.valor_filial.map((f) => f.filial_id)]}`,
        dt_inicial: `${this.dt_inicial}`,
        dt_final: `${this.dt_final}`,
        filtro: "FASE",
      };
      const url = await `${baseApiUrl}/jur/indicadores/kpijurFase`;
      axios
        .get(url, { params })
        .then((res) => {
          this.kpifase = res.data;
          this.updateChartDataFase();
        })
        .catch(showError);
    },
    async updateChartDataFase() {
      this.seriesfase = [
        {
          name: "Fase",
          data: this.kpifase.map((item) => parseInt(item.dia)),
        },
      ];
      this.$refs.chartfase.updateOptions({
        xaxis: {
          categories: this.kpifase.map((r) => r.fase),
        },
      });
    },

    /// filtros por solicitante 19/02/2024
    async loadKpiNatureza() {
      let params = {
        psg: this.user.psg,
        empresa_id: `${[this.user.id_empresa]}`,
        filial_id: `${[this.valor_filial.map((f) => f.filial_id)]}`,
        dt_inicial: `${this.dt_inicial}`,
        dt_final: `${this.dt_final}`,
        filtro: "NATUREZA",
      };
      const url = await `${baseApiUrl}/jur/indicadores/kpijurNatureza`;
      axios
        .get(url, { params })
        .then((res) => {
          this.kpifuncionario = res.data;
          this.updateChartDataNatureza();
        })
        .catch(showError);
    },

    async updateChartDataNatureza() {
      this.seriesNatureza = [
        {
          name: "Qtd",
          data: this.kpifuncionario.map((item) => parseInt(item.dia)),
        },
      ];
      this.$refs.chartfuncionario.updateOptions({
        xaxis: {
          categories: this.kpifuncionario.map((r) => r.natureza),
        },
      });
    },

    /// filtros por filial  getKpiInformaticaFilial
    async loadKpiFilial() {
      //this.isLoading = true; // Ative o indicador de carregamento
      let params = {
        psg: this.user.psg,
        empresa_id: `${[this.user.id_empresa]}`,
        filial_id: `${[this.valor_filial.map((f) => f.filial_id)]}`,
        dt_inicial: `${this.dt_inicial}`,
        dt_final: `${this.dt_final}`,
        filtro: "FILIAL",
      };
      const url = `${baseApiUrl}/jur/indicadores/kpijurFilial`;
      axios
        .get(url, { params })
        .then((res) => {
          this.kpifiliais = res.data;
          this.updateChartDataFilial();
          //    this.isLoading = false; // Desative o indicador de carregamento
        })
        .catch(showError);
    },

    async updateChartDataFilial() {
      this.graficoPizzaFilial.series = this.kpifiliais.map((item) =>
        parseInt(item.dia)
      );
      this.atualizarLabels();
    },

    async atualizarLabels() {
      this.graficoPizzaFilial.labels = await this.kpifiliais.map(
        (item) => item.filial_id
      );
      this.$refs.chart.updateOptions({
        labels: this.graficoPizzaFilial.labels,
      });
    },
  },

  mounted() {
    this.loadEmpresa();
    this.loadKpiDiario();
    this.loadKpiFase();
    this.loadKpiNatureza();
    this.loadKpiFilial();
    this.loadKpiResumo();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
</style>